import { TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE } from '../shared/abstract-boxes';
import { resolveTranslationKey } from './carrouselTranslationKeyResolver';
import { getCarrouselConfigurationOption } from './carrouselConfiguration';

export function CarrouselBoxViewConstructor(services, callbacks, context, siteTypeConfig) {

  let joint = services.joint;
  let companyId = context.companyId;

  return joint.shapes.html.AbstractBoxElementWithDragAndDropView.extend({
    isElementEditable: true,
    editElementModalController: 'editCarrouselElementController',
    editElementModalTemplate: require('./editCarrouselElement.modal.html'),
    displayedElementIndex: 0,
    angularTemplate: require('./CarrouselBoxView.html'),
    initialize: function () {
      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);
    },

    resolveTranslationKey: function (key) {
      return resolveTranslationKey(this.getType(), key);
    },

    getConfigurationOption: function (key) {
      return getCarrouselConfigurationOption(this.getType(), key);
    },

    getElementIndexAndTotalElementsAsText: function (elementIndex) {
      if (elementIndex === undefined) {
        elementIndex = this.displayedElementIndex + 1;
      }
      return elementIndex + '/' + this.angularScope.elementData.elements.length;
    },

    getCurrentElementTitle: function () {
      const element = this.getSelectedElementData();
      return element ? element.title : null;
    },

    getCurrentElementSubtitle: function () {
      const element = this.getSelectedElementData();
      return element ? element.subtitle : null;
    },

    getCurrentElementPictureUrl: function () {
      const element = this.getSelectedElementData();
      if (element && typeof element.pictureId === 'number') {
        return services.MediasFactory.pictureUrl(companyId, element.pictureId);
      }
      return '';
    },

    /**
     * Overriden from ElementView because elementData passed to modal is not view elementData but
     * just elementData of selected element
     */
    editElement: function () {
      // hide the error message
      this.$box.find('.invalid-text-length').addClass('ng-hide');
      this.resizeBox();

      services.$mdDialog.show({
        controller: this.editElementModalController,
        template: this.editElementModalTemplate,
        escapeToClose: false,
        locals: {
          context: context,
          elementData: angular.copy(this.getSelectedElementData()),
          parentElementData: this.angularScope.elementData,
          elementView: this
        }
      }).then(modalResult => {
        if (modalResult.type === 'ok') {
          this.angularScope.elementData.elements[this.displayedElementIndex] = modalResult.data;
          // to be sure angular detects a change in this.angularScope.elementData
          this.angularScope.elementData = angular.copy(this.angularScope.elementData);
          callbacks.updateSerializedGraph(this.model.graph);
          this.isBoxValid();
          this.resizeBox();
        } else if (modalResult.type === 'delete') {
          this.removeCarrouselElement();
        }
      });
    },

    editCarrouselConfiguration: function () {
      services.$mdDialog.show({
        controller: 'editCarrouselController',
        template: require('./editCarrousel.modal.html'),
        escapeToClose: false,
        locals: {
          context: context,
          elementData: angular.copy(this.angularScope.elementData),
          elementView: this
        }
      }).then(modalResult => {
        if (modalResult.type === 'ok') {
          this.angularScope.elementData.aspectRatio = modalResult.data.aspectRatio;
          this.angularScope.elementData.cardWidth = modalResult.data.cardWidth;
          this.angularScope.elementData.imageSize = modalResult.data.imageSize;
          this.angularScope.elementData.altText = modalResult.data.altText;
          this.angularScope.elementData = angular.copy(this.angularScope.elementData);
          callbacks.updateSerializedGraph(this.model.graph);
        }
      });
    },

    getSelectedElementData: function () {
      if (this.angularScope.elementData) {
        const elements = this.angularScope.elementData.elements;
        if (this.displayedElementIndex < elements.length) {
          return elements[this.displayedElementIndex];
        }
      }
      return null;
    },

    addCarrouselElement: function () {
      if (this.shouldDisableAddCarrouselElementBecauseOfButtons()) {
        this.$box.find('.invalid-number-of-buttons').removeClass('ng-hide');
      }
      else if (this.shouldDisableAddCarrouselElementBecauseOfText()) {
        this.$box.find('.invalid-text-length').removeClass('ng-hide');
      } else {
        this.$box.find('.invalid-number-of-buttons').addClass('ng-hide');
        this.$box.find('.invalid-text-length').addClass('ng-hide');
        const elements = this.angularScope.elementData.elements;
        let maxElementId = 0;
        for (let element of elements) {
          if (maxElementId < element.carrouselElementId) {
            maxElementId = element.carrouselElementId;
          }
        }
        if (elements.length < this.getConfigurationOption('max-carrousel-elements-number')) {
          const newElement = {
            carrouselElementId: maxElementId + 1,
            backgroundColor: '#FFFFFF',
            temporaryElement: true
          };
          this.displayedElementIndex++;
          elements.splice(this.displayedElementIndex, 0, newElement);
          this.updateButtonGroupsAfterElementsUpdate();
          this.isBoxValid();
          this.resizeBox();
          this.editElement();
        }
      }
      this.resizeBox();
    },

    /**
     * Removes the currently displayed carrousel element
     * (if it is not the last element).
     */
    removeCarrouselElement: function () {
      const elements = this.angularScope.elementData.elements;
      if (elements.length > 1) {
        elements.splice(this.displayedElementIndex, 1);
      }
      // to be sure angular detects a change in this.angularScope.elementData
      this.angularScope.elementData = angular.copy(this.angularScope.elementData);
      callbacks.updateSerializedGraph(this.model.graph);
      this.updateButtonGroupsAfterElementsUpdate();
      this.isBoxValid();
      this.resizeBox();
      this.updateBox();
    },


    /**
     * Switches the currently displayed page to the previous page,
     * if not currently displaying the first page
     */
    previousCarrouselElement: function () {
      if (this.displayedElementIndex > 0) {
        this.displayedElementIndex--;
        this.resizeBoxAfterSetTimeout();
      }
    },

    resizeBoxAfterSetTimeout: function () {
      setTimeout(() => this.resizeBox());
    },

    /**
     * Switches the currently displayed page to the next page,
     * if not currently displaying the last page
     */
    nextCarrouselElement: function () {
      if (this.displayedElementIndex < this.angularScope.elementData.elements.length - 1) {
        this.displayedElementIndex++;
        this.resizeBoxAfterSetTimeout();
      }
    },

    afterDeserialize: function (shouldResize) {
      this.updateHeaderGroupsIndexes();
      this.enableOrDisableAddButtons();
      if (shouldResize) {
        this.resizeBox();
      }
    },

    /*
     * This function updates the 'add button' buttons accordingly.
     */
    enableOrDisableAddButtons: function () {
      let buttonsNumber = 0;
      const numberOfSlides = this.angularScope.elementData.elements.length;
      for (let child of this.model.getEmbeddedCells()) {
        switch (child.get('type')) {
          case 'html.CarrouselButtonGroupHeader':
            buttonsNumber = 0;
            break;
          case 'html.CarrouselElementButton':
            buttonsNumber++;
            break;
          case 'html.CarrouselAddButtonButton':
            if (numberOfSlides === 1) {
              child.get('elementData').disabled = buttonsNumber >= this.getConfigurationOption('max-carrousel-element-buttons-number-one-slide');
            } else {
              child.get('elementData').disabled = buttonsNumber >= this.getConfigurationOption('max-carrousel-element-buttons-number-several-slide');
            }
            break;
          default:
            break;
        }
      }
    },

    /**
     * In case we have a single-slide Carrousel with 4 buttons (which is allowed since the carousel is
     * seen as a Buttons Template for this case) we must deny the possibility to add another slide unless 
     * the user remove one of the buttons, as the Carrousel Template allows up to 3 buttons. 
     */
    shouldDisableAddCarrouselElementBecauseOfButtons: function () {
      const numberOfSlides = this.angularScope.elementData.elements.length;
      if (numberOfSlides === 1) {
        const numberOfButtonsAllowedInASingleSlide = this.getConfigurationOption('max-carrousel-element-buttons-number-one-slide');
        const numberOfButtonsAllowedInSeveralSlides = this.getConfigurationOption('max-carrousel-element-buttons-number-several-slide');
        const numberOfButtons = this.countButtons(this.angularScope.elementData.elements[0]);
        if (numberOfButtonsAllowedInASingleSlide > numberOfButtonsAllowedInSeveralSlides &&
          numberOfButtons === this.getConfigurationOption('max-carrousel-element-buttons-number-one-slide')
          && this.getConfigurationOption('carrousel-must-check-number-of-button-validity')) {
          return true;
        }
      }
      return false;
    },

    /**
     * The slide text max length is 160 with one slide, but 120 with more than one slide.
     */
    shouldDisableAddCarrouselElementBecauseOfText: function () {
      const numberOfSlides = this.angularScope.elementData.elements.length;
      if (numberOfSlides === 1) {
        let maxTextLengthWithSeveralSlide = 0;
        if (this.getConfigurationOption('carrousel-element-subtitle-max-length-several-slide')) {
          maxTextLengthWithSeveralSlide = this.getConfigurationOption('carrousel-element-subtitle-max-length-several-slide');
        }
        let subtitleTextLength = 0;
        if (this.angularScope.elementData.elements[0].subtitle) {
          subtitleTextLength = this.angularScope.elementData.elements[0].subtitle.length;
        }
        if (subtitleTextLength > maxTextLengthWithSeveralSlide) {
          return true;
        }
      }
      return false;
    },

    /**
     * Updates the text to be displayed by button group headers
     * with the index of their 'owner' carrousel element and total number of groups.
     * Needs to be called after inserting or removing a carrousel element.
     */
    updateHeaderGroupsIndexes: function () {
      const totalGroupsNumber = this.angularScope.elementData.elements.length;
      let i = 1;
      for (let child of this.model.getEmbeddedCells()) {
        if (child.get('type') === 'html.CarrouselButtonGroupHeader') {
          child.get('elementData').groupIndex = i++;
          child.get('elementData').totalGroupsNumber = totalGroupsNumber;
        }
      }
    },

    /**
     * Adds a new button within an exisiting button group
     * We loop on all children and we unembed all children
     * starting from the 'add button' item that has the given carrouselElementId,
     * then we insert a new button,
     * then we re-embed all unembeded children.
     */
    addChildClicked: function (buttonId, carrouselElementId) {
      let unembeded = [];
      let unembedding = false;
      for (let child of this.model.getEmbeddedCells()) {
        if (this.childsCarrouselElementId(child) === carrouselElementId
          && child.get('type') === 'html.CarrouselAddButtonButton') {

          unembedding = true;
        }
        if (unembedding) {
          this.model.unembed(child);
          unembeded.push(child);
        }
      }
      let button = this.createCarrouselElementButton(buttonId, carrouselElementId);
      this.model.embed(button);
      this.model.graph.addCell(button);
      unembeded.forEach(child => this.model.embed(child));
      this.enableOrDisableAddButtons();
      this.isBoxValid();
      this.resizeBox();
    },

    /*
     * Adds/removes a button group after adding/removing a carrousel element
     */
    updateButtonGroupsAfterElementsUpdate: function () {
      // let's reference the box's children before they are unembeded
      const childrenBeforeUpdate = this.model.getEmbeddedCells();
      this.unembedOrRemoveChildren();
      this.reembedChildren(childrenBeforeUpdate);
      this.updateHeaderGroupsIndexes();
      this.enableOrDisableAddButtons();
      //this.resizeBox(); Caller is responsible to call resizeBox after 
      if (this.displayedElementIndex >= this.angularScope.elementData.elements.length) {
        this.displayedElementIndex = this.angularScope.elementData.elements.length - 1;
      }
    },


    /*
     * When the carrousel elements have been updated, 
     * all children (buttons, group headers and 'add button' items)
     * need to either be unembeded to be sorted acording to their corresponding carrousel element,
     * or removed completely if their corresponding carrousel element has been removed
     */
    unembedOrRemoveChildren: function () {
      for (let child of this.model.getEmbeddedCells()) {
        let carrouselElementId = this.childsCarrouselElementId(child);
        if (!carrouselElementId || this.hasElementWithGivenCarrouselElementId(carrouselElementId)) {
          this.model.unembed(child);
        } else {
          child.remove(); // this will remove any outgoing links too
        }
      }
    },

    /**
     * Tells whether our model contains a carrousel element
     * that has the given id
     */
    hasElementWithGivenCarrouselElementId: function (id) {
      let result = false;
      this.angularScope.elementData.elements.forEach(element => {
        if (element.carrouselElementId === id) {
          result = true;
        }
      });
      return result;
    },

    /**
     * Returns the id of the carrousel element to which this child belongs
     * If the given child is a button or a button group header, 
     * that id is stored in its 'carrouselElementId' model property;
     * if it is an 'add button' child, the id is stored in its addChildId property.
     */
    childsCarrouselElementId: function (child) {
      if (child.get('type') === 'html.Next') {
        return null;
      }
      return child.get('elementData').carrouselElementId;
    },


    /*
     * For each carrousel element in the model,
     * if we can find buttons (and a header and a 'add a button' item)
     * that have a matching carrouselElementId, 
     * we embed them; otherwise we embed a new header and 'add a button' item.
     */
    reembedChildren: function (childrenBeforeUpdate) {
      for (let element of this.angularScope.elementData.elements) {
        const currentElementId = element.carrouselElementId;
        let foundChildren = false;
        for (let child of childrenBeforeUpdate) {
          if (child.get('type') === 'html.Next') {
            this.model.embed(child);
          } else if (this.childsCarrouselElementId(child) === currentElementId) {
            this.model.embed(child);
            foundChildren = true;
          }
        }
        if (!foundChildren) {
          this.embedNewButtonGroupHeaderAndAddButton(currentElementId);
        }
      }
    },

    /**
     * Adds a button group header and an 'add button' button to this box,
     * assigning them the given carrousel element id.
     */
    embedNewButtonGroupHeaderAndAddButton: function (carrouselElementId) {
      this.addCarrouselButtonGroupHeader(carrouselElementId);
      this.addCarrouselAddButtonButton(carrouselElementId);
    },

    addCarrouselButtonGroupHeader: function (carrouselElementId) {
      let header = this.createCarrouselButtonGroupHeader(null, carrouselElementId);
      this.model.graph.addCell(header);
      this.model.embed(header);
    },

    addCarrouselAddButtonButton: function (carrouselElementId) {
      let button = this.createCarrouselAddButtonButton(null, carrouselElementId);
      this.model.graph.addCell(button);
      this.model.embed(button);
    },

    createCarrouselButtonGroupHeader: function (id,
      carrouselElementId,
      position = TMP_ELEMENT_POSITION,
      size = TMP_ELEMENT_SIZE,
      elementData = null) {
      if (!elementData) {
        elementData = {
          carrouselElementId: carrouselElementId
        };
      }
      let header = new joint.shapes.html.CarrouselButtonGroupHeader({ id, position, size, elementData });

      return header;
    },

    createCarrouselAddButtonButton: function (id,
      carrouselElementId,
      position = TMP_ELEMENT_POSITION,
      size = TMP_ELEMENT_SIZE,
      elementData = null) {
      if (!elementData) {
        elementData = {
          carrouselElementId: carrouselElementId
        };
      }
      let button = new joint.shapes.html.CarrouselAddButtonButton({ id, position, size, elementData });

      return button;
    },

    createCarrouselElementButton: function (id,
      carrouselElementId,
      position = TMP_ELEMENT_POSITION,
      size = TMP_ELEMENT_SIZE,
      elementData = null) {

      if (!elementData) {
        elementData = {
          type: 'postback',
          carrouselElementId: carrouselElementId
        };
      }
      let button = new joint.shapes.html.CarrouselElementButton({ id, position, size, elementData });

      return button;
    },

    /**
     * We check the uniformity of Line Carrousels
     * 
     * At first this function was called updateBox, overriden from abstract-views
     * but it didn't work well, so we create this function and we have to make sure it's called correctly
     * We need to check after 5 types of modification:
     * element added, element removed, element edited, button added, button removed
     */
    isBoxValid: function () {
      if (this.getConfigurationOption('carrousel-must-have-uniform-elements')) {
        const valid = this.areElementsUniform();
        this.model.setBoxValid(valid);
        if (valid) {
          this.$box.find('.all-elements-uniform-message').addClass('ng-hide');
        } else {
          this.$box.find('.all-elements-uniform-message').removeClass('ng-hide');
        }
      }
      this.$box.find('.invalid-number-of-buttons').addClass('ng-hide');
    },

    /**
     * For each carrousel element in the model,
     * we check that they have the same number of buttons
     * and either all of them have title (or image) or none of them have title (or image)
     */
    areElementsUniform: function () {
      const elements = this.angularScope.elementData.elements;
      let hasImage = !!elements[0].pictureId;
      let hasTitle = !!elements[0].title;
      let numberOfButtons = this.countButtons(elements[0]);

      for (let element of elements.slice(1)) {
        if (numberOfButtons !== this.countButtons(element)
          || hasImage !== !!element.pictureId
          || hasTitle !== !!element.title) {
          return false;
        }
      }
      return true;
    },

    countButtons: function (element) {
      const currentElementId = element.carrouselElementId;
      let numberOfButtons = 0;
      for (let child of this.model.getEmbeddedCells()) {
        if (this.childsCarrouselElementId(child) === currentElementId
          && child.get('type') === 'html.CarrouselElementButton') {
          numberOfButtons++;
        }
      }
      return numberOfButtons;
    },

  });
}
